/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 1869
// module chunks = 0